import { Box } from "@mui/material";

const ChartContainer = ({ children, onMouseEnter = () => {}, onMouseLeave = () => {} }) => {
  return (
    <Box sx={{ width: 1, position: "relative", height: 1 }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {children}
    </Box>
  );
};

export default ChartContainer;
